import api from '@config/axiosConfig';
import { configuredFetchBaseQuery } from '@config/rtkQuery';
import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import { createApi } from '@reduxjs/toolkit/dist/query/react';

export const reportsApi = createApi({
  reducerPath: 'reportsApi',
  baseQuery: configuredFetchBaseQuery(),
  endpoints: (builder) => ({
    getAccountSnapshot: builder.query({
      query: () => ({ url: 'customer/reports/account-snapshot' }),
      transformResponse: (response) => {
        const total = {
          dids_amount: 0,
          country: {
            name: 'Total',
            flag_href: '',
          },
          cancellations_30_days: 0,
          minutes_last_7_days: {
            inbound: 0,
            outbound: 0,
          },
        };
        response.forEach((item) => {
          total.dids_amount += item.dids_amount;
          total.cancellations_30_days += item.cancellations_30_days;
          total.minutes_last_7_days.inbound += item.minutes_last_7_days.inbound;
          total.minutes_last_7_days.outbound +=
            item.minutes_last_7_days.outbound;
        });
        return [...response, total];
      },
    }),
    getTrafficTypes: builder.query({
      query: () => ({ url: 'customer/reports/pcdrs/traffic-types' }),
    }),
    getPcdrs: builder.query({
      query: (arg) => {
        const url = 'customer/reports/pcdrs';
        const { page, size, ...params } = arg;
        return { url, params: { page, page_size: size, ...params } };
      },
    }),
    getDidGroupsReport: builder.query({
      query: (arg) => {
        const url = 'reports/didGroups/';
        const { page, size, ...params } = arg;
        return { url, params: { page, page_size: size, ...params } };
      },
    }),
  }),
});

export const getDidGroupPlans = createAsyncThunk(
  'reports/didGroup/plans/',
  async ({ countryID }, thunkAPI) => {
    try {
      const res = await api({ thunkAPI }).get(`/reports/didGroup/plans/`, {
        params: { country: countryID },
      });
      const { data, status } = res;
      if (status === 200) {
        return data;
      }
      return thunkAPI.rejectWithValue(data);
    } catch (err) {
      return thunkAPI.rejectWithValue(err.response.data);
    }
  }
);

const initialState = {
  snapshot: { isLoading: false, data: [] },
  didGroup: { isLoading: false, data: [] },
  cdrs: { isLoading: false, data: [] },
  filters: {
    area: { isLoading: false, data: [] },
    country: { isLoading: false, data: [] },
    destination: { isLoading: false, data: [] },
    plans: { isLoading: false, data: [] },
    trafficTypes: { isLoading: false, data: [] },
  },
};

const reportsSlice = createSlice({
  name: 'reports',
  initialState,
  reducers: {
    clearDidGroupPlans: (state) => {
      state.filters.plans = initialState.filters.plans;
    },
  },
  extraReducers: (builder) =>
    builder
      .addCase(getDidGroupPlans.pending, (state) => {
        state.filters.plans.isLoading = true;
      })
      .addCase(getDidGroupPlans.fulfilled, (state, action) => {
        state.filters.plans.isLoading = false;
        state.filters.plans.data = action.payload;
      })
      .addCase(getDidGroupPlans.rejected, (state) => {
        state.filters.plans.isLoading = false;
      }),
});

export const { clearDidGroupPlans } = reportsSlice.actions;
export default reportsSlice.reducer;
